import React from "react";
import ReportDetail from "../../ReportDetail";
import ProductsAvailability from "./ProductsAvailability";

const ProductsAvailabilityPage = () => {
  return (
    <ReportDetail title="product_availability_report">
      <ProductsAvailability />
    </ReportDetail>
  );
};

export default ProductsAvailabilityPage;
